(() => {
  const money=n=>new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(n);
  const init=(root=document)=>{
    root.querySelectorAll('[data-dn-blanket]').forEach(section=>{
      if(section.dataset.blanketReady)return;
      section.dataset.blanketReady='true';
      const select=section.querySelector('[data-dn-blanket-colour]');
      const photos=[...section.querySelectorAll('[data-dn-blanket-photo]')];
      const showPhoto=(image,key)=>{
        const main=section.querySelector('[data-dn-gallery-main]');
        const videoPanel=section.querySelector('[data-dn-blanket-video]');
        const imagePanel=section.querySelector('[data-dn-zoom]');
        const isVideo=key==='video'&&Boolean(videoPanel);
        if(videoPanel){videoPanel.hidden=!isVideo;if(!isVideo)videoPanel.querySelector('video')?.pause();}
        imagePanel.hidden=isVideo;imagePanel.style.display=isVideo?'none':'';
        photos.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.dnBlanketPhoto===key)));
        if(isVideo)return;
        main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=image;
        const active=photos.find(b=>b.dataset.dnBlanketPhoto===key);const cropped=false;
        main.alt=active?.getAttribute('aria-label')||'Quilted comfort blanket';
        section.querySelector('[data-dn-blanket-frame]').dataset.cropped=String(cropped);
        const zoom=section.querySelector('[data-dn-zoom-image]');zoom.src=image;zoom.alt=main.alt;
        section.querySelector('[data-dn-image-dialog]').dataset.cropped=String(cropped);
        photos.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.dnBlanketPhoto===key)));
      };
      const apply=(key,update=true)=>{
        const option=[...select.options].find(o=>o.value===key);if(!option)return;
        select.value=key;
        showPhoto(option.dataset.image,key);
        section.querySelectorAll('[data-dn-blanket-swatch]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.dnBlanketSwatch===key)));
        const add=section.querySelector('[data-dn-draft-add]');if(add){add.dataset.dnDraftAdd='blanket-'+key;add.dataset.title='Water Resistant Dog Blanket — '+option.text;add.dataset.image=option.dataset.image;}
        section.querySelectorAll('[data-dn-pair-link]').forEach(a=>{const u=new URL(a.href);u.searchParams.set('blanket',key);a.href=u.pathname+u.search;});
        if(update){const u=new URL(location.href);u.searchParams.set('colour',key);history.replaceState({},'',u);}
      };
      select.addEventListener('change',()=>apply(select.value));
      section.querySelectorAll('[data-dn-blanket-swatch]').forEach(b=>b.addEventListener('click',()=>apply(b.dataset.dnBlanketSwatch)));
      photos.forEach(b=>b.addEventListener('click',()=>{if(b.dataset.dnBlanketPhoto==='hero'||b.hasAttribute('data-dn-blanket-feature')){showPhoto(b.dataset.image,b.dataset.dnBlanketPhoto);}else apply(b.dataset.dnBlanketPhoto);}));
      const requested=new URL(location.href).searchParams.get('colour');if(requested)apply(requested,false);
    });
    root.querySelectorAll('[data-dn-blanket-addon]').forEach(addon=>{
      if(addon.dataset.addonReady)return;addon.dataset.addonReady='true';
      const scope=addon.closest('[data-dn-pdp]'),check=addon.querySelector('[data-dn-bundle-check]'),select=addon.querySelector('[data-dn-bundle-colour]');
      const colours={'dark-grey':'#57575a','light-grey':'#b8b8b5','red-grey':'linear-gradient(135deg,#9a595c 50%,#92928f 50%)','white':'#f6f3ec','black':'#242424','khaki':'#b2a48b','red':'#a43d42','dark-blue':'#27394f'};
      const swatches=document.createElement('div');
      swatches.className='dn-addon-colour-circles';swatches.setAttribute('role','group');
      const label=addon.querySelector('label[for="'+select.id+'"]');
      swatches.setAttribute('aria-label',label?.textContent||'Colour');
      const selectedName=document.createElement('span');selectedName.className='dn-addon-selected-colour';
      selectedName.setAttribute('aria-live','polite');
      [...select.options].forEach(option=>{
        const button=document.createElement('button');button.type='button';
        button.className='dn-addon-colour-circle';button.dataset.colour=option.value;
        button.setAttribute('aria-label',option.text);button.title=option.text;
        button.style.setProperty('--swatch-colour',colours[option.value]||'#aaa');
        button.addEventListener('click',()=>{if(option.disabled)return;select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));});
        swatches.append(button);
      });
      select.insertAdjacentElement('afterend',swatches);swatches.insertAdjacentElement('afterend',selectedName);
      select.hidden=true;select.style.display='none';
      const update=()=>{
        selectedName.textContent=select.selectedOptions[0]?.text||'';
        swatches.querySelectorAll('button').forEach(button=>{
          const option=[...select.options].find(option=>option.value===button.dataset.colour);
          button.disabled=Boolean(option?.disabled);button.setAttribute('aria-pressed',String(button.dataset.colour===select.value));
        });
        addon.querySelector('[data-dn-addon-choices]').hidden=!check.checked;
        const priceText=scope.querySelector('[data-dn-price]')?.textContent||'0';
        const price=Number(priceText.replace(/[^\d.]/g,''));
        const quantity=Number(scope.querySelector('[data-dn-presentation-quantity],.dn-native-form [name=quantity],.dn-bed-native-form [name=quantity]')?.value)||1;
        addon.querySelector('[data-dn-bundle-total]').textContent=money((price+30)*quantity);
        const stickyPrice=scope.querySelector('[data-dn-sticky-price]');
        if(stickyPrice)stickyPrice.textContent=(/^From\s/i.test(priceText.trim())?'From ':'')+money((price+(check.checked?30:0))*quantity);
        addon.querySelector('[data-dn-addon-image]').src=select.selectedOptions[0].dataset.image;
        addon.querySelector('[data-dn-addon-image]').style.objectPosition='center top';
      };
      check.addEventListener('change',update);select.addEventListener('change',update);scope.addEventListener('change',update);scope.addEventListener('input',update);
      const price=scope.querySelector('[data-dn-price]');if(price)new MutationObserver(update).observe(price,{childList:true,subtree:true,characterData:true});
      const requested=new URL(location.href).searchParams.get('blanket');if(requested&&[...select.options].some(o=>o.value===requested)){select.value=requested;check.checked=true;addon.open=true;}
      update();
    });
  };
  init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();


